import { makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import CheckIcon from "@material-ui/icons/Check";

function CompareTable() {
  const useStyles = makeStyles((theme) => ({
    main: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    compareTable: {
      border: "1px solid grey",
      width: "65vw",
      maxWidth: "600px",
      fontFamily: "Gordita Regular, Helvetica Neue, Helvetica, sans-serif",
      boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)",
      margin: "20px auto",
      borderCollapse: "collapse",
      backgroundColor: "white",
      fontSize: "14px",
      [theme.breakpoints.down("xs")]: {
        width: "80vw",
      },

      "& tr": {
        textAlign: "center",
      },
      "& th": {
        backgroundColor: "rgb(146,135,255)",
        color: "white",
        padding: "10px",
        border: "1px solid grey",
      },
      "& td": {
        width: "10%",
        // maxWidth: "50px",
        padding: "5px 10px",
        border: "1px solid grey",
      },
    },
    positive: {
      fontSize: "25px",
      color: "#31B558",
      display: "block",
      margin: "auto",
    },
    positivey: {
      fontSize: "25px",
      color: "#E8C743",
      display: "block",
      margin: "auto",
    },
    negative: {
      fontSize: "25px",
      color: "#EB343B",
      display: "block",
      margin: "auto",
    },
    greenText: {
      fontSize: "12px",
      color: "#8DBE6D",
    },
    yellowText: {
      fontSize: "12px",
      color: "#CFAC46",
    },
    hiddenText: {
      visibility: "hidden",
    },
  }));

  const classes = useStyles();
  return (
    <div className={classes.main}>
      <table className={classes.compareTable}>
        <thead>
          <tr>
            <th></th>
            <th>Website</th>
            <th>Android and iOS App</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Add classes</td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
          </tr>
          <tr>
            <td>Create an answer key</td>
            <td className={classes.greenText}>
              <div className={classes.box}>
                <span className={classes.hiddenText}>(All question types)</span>

                <CheckIcon className={classes.positive} />
                <span className={classes.bob}>(All question types)</span>
              </div>
            </td>
            <td className={classes.yellowText}>
              <span className={classes.hiddenText}>(Only multiple Choice)</span>
              <CheckIcon className={classes.positivey} />
              (Only multiple Choice)
            </td>
          </tr>
          <tr>
            <td>Add students to classes</td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
          </tr>
          <tr>
            <td>Download paper and answer sheets for printing</td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
            <td>
              <CloseIcon className={classes.negative} />
            </td>
          </tr>
          <tr className="active-row">
            <td>Scan paper answer sheets</td>
            <td>
              <CloseIcon className={classes.negative} />
            </td>
            <td className={classes.greenText}>
              <span className={classes.hiddenText}>
                (Both multiple-choice written answer sheets)
              </span>
              <CheckIcon className={classes.positive} />
              (Both multiple-choice and written answer sheets)
            </td>
          </tr>
          <tr className="active-row">
            <td>Release online answer sheets to students</td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
          </tr>
          <tr className="active-row">
            <td>View results</td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
            <td className={classes.yellowText}>
              <span className={classes.hiddenText}>(Basic results only)</span>
              <CheckIcon className={classes.positivey} />
              (Basic results only)
            </td>
          </tr>
          <tr className="active-row">
            <td>Release results to students</td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
          </tr>
          <tr className="active-row">
            <td>Student Portal</td>
            <td>
              <CheckIcon className={classes.positive} />
            </td>
            <td>
              <CloseIcon className={classes.negative} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default CompareTable;
